import axios from 'axios'

const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}

export const generate = async ({ html } : { html: string }): Promise<void> => {
  return axios
    .post('https://zs7bkx7obf.execute-api.us-west-2.amazonaws.com/production/pdf', { html }, {
      withCredentials: false
    }).then((res) => {
      const url = window.URL.createObjectURL(b64toBlob(res.data, 'application/pdf'))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `resultado-exame-${+new Date()}.pdf`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    })
}
